import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import React from "react";
import LogResults from "./LogResults";
import * as APIModels from "../../models";
import { Globals } from "../../helpers/globals";

const DatabaseCard = (params: {
    statuses: Array<APIModels.MatterLogResponse>;
    expand: boolean;
    setExpanded: React.Dispatch<React.SetStateAction<boolean>>;
    title?: string;
}) => {
    return (
        <>
            {params.statuses.length > 0 && (
                <Accordion
                    sx={{ padding: "8px" }}
                    expanded={params.expand}
                    TransitionProps={{ timeout: 500 }}
                    onClick={() => {
                        params.setExpanded(!params.expand);
                    }}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMore />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <h4>{params.title}</h4>
                    </AccordionSummary>
                    <AccordionDetails>
                        <h5>
                            {Globals.currentUserValue.organizationName}
                            's Database
                        </h5>

                        <LogResults logs={params.statuses} />
                    </AccordionDetails>
                </Accordion>
            )}
        </>
    );
};

export default DatabaseCard;
